import { IS_PROD } from "./constants"

const showFlag = !IS_PROD

export const Flags = {
  General: {
    Example: showFlag,
    PortfolioPDF: showFlag,
    GridEscPublic: true,
    NewDevExp: true,
  },
} as const

export type FlagsType = typeof Flags
